import { preventScroll, restoreScroll } from "../utils/prevent-scroll";

document.addEventListener("DOMContentLoaded", () => {
  let menuClosed = false;
  const menu = document.querySelector(".Menu");
  const searchToggleCheckbox = document.querySelector("#search-checkbox");
  [...document.querySelectorAll("[data-menu-toggle]")].forEach(
    (toggleButton) => {
      toggleButton.addEventListener("click", () => {
        menu.classList.add("transition-transform");
        menuClosed = menu.classList.toggle("translate-x-full");

        searchToggleCheckbox.checked = !menuClosed;

        toggleButton.classList.toggle("open");

        const hamburgerStrokes = document.querySelectorAll(".Hamburger-stroke");
        hamburgerStrokes.forEach((stroke) => {
          stroke.classList.toggle("active");
        });

        if (menuClosed) {
          restoreScroll(0);
        } else {
          preventScroll(0);
        }
      });
    }
  );

  // Handle submenus and submenu button
  const subMenus = menu.querySelectorAll(".menu-item-has-children");
  subMenus.forEach((subMenu) => {
    subMenu.addEventListener("click", (e) => {
      const button = e.target.closest(".Menu-subMenuButton");
      if (button) {
        e.preventDefault();
        e.stopPropagation();
        // handle toggle
        button.classList.toggle("is-active");
        if (button.classList.contains("is-active")) {
          subMenu
            .querySelector(".Menu-subMenu-wrapper")
            .setAttribute("aria-hidden", false);
        } else {
          subMenu
            .querySelector(".Menu-subMenu-wrapper")
            .setAttribute("aria-hidden", true);
        }
      }
    });
  });

  // Close all submenus when clicking outside
  function closeAllSubNavs() {
    [...document.querySelectorAll(".menu-item-has-children")].forEach(
      (submenu) => {
        submenu
          .querySelector(".Menu-subMenuButton")
          .classList.remove("is-active");
        submenu
          .querySelector(".Menu-subMenu-wrapper")
          .setAttribute("aria-hidden", true);
      }
    );
  }
  document.addEventListener("click", closeAllSubNavs);
});
